/**
 * Helper function to scroll to the top of the page on page transitions. Loaded in `App.tsx`
 */

import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';


// TODO: properly set this up
// @ts-ignore
function ScrollToTop({ history }) {
    useEffect(() => {
        const unlisten = history.listen(() => {
            window.scrollTo(0, 0);
        });
        return () => {
            unlisten();
        }
    }, []);

    return (null);
}

export default withRouter(ScrollToTop);